var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer-disappear footer text-white text-center"},[_c('p',[_c('em',[_vm._v("Copyright © "+_vm._s(_vm.getThisYear())+" "),_c('br'),_vm._v("All rights reserved to I.C.I.P.E.")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }